import { Theme } from "@material-ui/core"
import Grid from "@material-ui/core/Grid"
import makeStyles from "@material-ui/core/styles/makeStyles"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import TextField from "@material-ui/core/TextField"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import FormGroup from "@material-ui/core/FormGroup"
import Switch from "@material-ui/core/Switch"
import React, { Fragment } from "react"
import FieldSelect from "Components/Table/FieldSelect"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import ContentTypeSelect from "../WeiboTool/ContentTypeSelect"
import { useCreateWeiboDraft } from "./hooks"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: "absolute",
        width: "100%",
        height: "100%",
    },
    timeBlock: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginTop: 20,
    },
    input: {
        width: "100%",
        marginTop: 10,
    },
}))

const WeiboCreate = () => {
    const classes = useStyles()
    const {
        callback, cancelCallback, dialogData,
        disabled, external,
        text, handleChange,
        handleChangeContentType,
        handleChangeLottery,
        handleChangeMicro,
        handleChangeArticleType,
    } = useCreateWeiboDraft()
    return (
        <Fragment>
            <BoardConfirmModal
                title="创建预约"
                confirmCallback={callback}
                cancelCallback={cancelCallback}
                modalShow={dialogData.show}
                disabled={disabled}
            >
                <Grid item>
                    <TextField
                        label="内容"
                        value={text}
                        onChange={handleChange}
                        className={classes.input}
                    />
                </Grid>
                <Grid item>
                    <FormControl className={classes.input}>
                        <InputLabel>内容形式</InputLabel>
                        <ContentTypeSelect onChange={handleChangeContentType} />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl className={classes.input}>
                        <InputLabel >文章类型</InputLabel>
                        <FieldSelect
                            tableName="article_type"
                            onChange={handleChangeArticleType}
                            whereQuery={"where: {hidden: {_eq: false}}"}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl component="fieldset" className={classes.input}>
                        <FormGroup aria-label="position" row>
                            <FormControlLabel
                                value="抽奖"
                                control={
                                    <Switch
                                        color="primary"
                                        checked={external.isLottery}
                                        onChange={handleChangeLottery}
                                    />
                                }
                                label="抽奖"
                                labelPlacement="start"
                            />
                            <FormControlLabel
                                value="微任务"
                                control={
                                    <Switch
                                        color="primary"
                                        checked={external.isMicro}
                                        onChange={handleChangeMicro}
                                    />
                                }
                                label="微任务"
                                labelPlacement="start"
                            />
                        </FormGroup>
                    </FormControl>
                </Grid>
            </BoardConfirmModal>
        </Fragment>
    )
}

export default WeiboCreate
